import callForEachNode from '@utils/callForEachNode'
import getThemeByEnum, { Themes } from './getThemeByEnum'

const applyTheme = (themeName: Themes) => {
  const root = document.documentElement
  const theme = getThemeByEnum(themeName)

  callForEachNode(theme, (cssVar, value) => {
    root.style.setProperty(cssVar, value)
  })
}

export default applyTheme
